import {field} from "../../generic/tables";
import EditModalChildren from "./EditModalChildren";
import DirectoryTemplate from "../../directories/DirectoryTemplate";
import {ENTITIES, getPermissions} from "../../../lib/utils/hooks/useRoleSystem";
import {t} from "i18next";



const Formats = (props) => {
    return <DirectoryTemplate
        fields={[
            field(t('constructor.formats.name'), true, "name"),
            field(t('constructor.formats.description'), true, "description"),
        ]}
        editable
        deletable
        entityName={'formats'}
        EditModalChildren={EditModalChildren}
        permissions={getPermissions(ENTITIES.FORMATS)}
        isNameFieldSearch
        searchPlaceholder={t('constructor.directoryTemplate.search.formats')}
        {...props}
    />
}

export default Formats